import { DndContext } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import { useSortableItemsControls } from 'shared/hooks/use-sortable-items-controls';
import { useSortableSensors } from 'shared/hooks/use-sortable-sensors';
import {
  ViewOptionsSectionEntry,
  ViewOptionsSectionId,
} from 'shared/types/view-options-section';

import { ViewOptionsSection } from './components/view-options-section';
import { useCalendarAccountSections } from './use-calendar-account-sections';
import { useViewOptionsSectionOrder } from './use-view-options-section-order';

export const SideNavigationViewOptions: React.FC = () => {
  const accounts = useCalendarAccountSections();

  const sections = useMemo<ViewOptionsSectionEntry[]>(
    () => [
      { id: ViewOptionsSectionId.Show },
      ...accounts.map((account) => ({ id: account.id, account })),
      { id: ViewOptionsSectionId.LifeAreas },
    ],
    [accounts],
  );

  const { sections: orderedSections, onReorder } =
    useViewOptionsSectionOrder(sections);
  const sensors = useSortableSensors();

  const { items, handleDragStart, handleDragCancel, handleDragEnd } =
    useSortableItemsControls({
      items: orderedSections,
      onDragEnd: onReorder,
    });

  return (
    // No `measuring` override: a raw rect re-measures the drag translate back in when a section unmounts its body mid-drag.
    <DndContext
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      sensors={sensors}
    >
      <SortableContext
        items={items.map(({ id }) => id)}
        strategy={verticalListSortingStrategy}
      >
        {items.map((section, index) => (
          <ViewOptionsSection
            key={section.id}
            section={section}
            isFirst={index === 0}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};
